"use strict";
const React = require('react');
const react_redux_1 = require('react-redux');
const tasks_1 = require('../actions/tasks');
const selectors_1 = require('../selectors');
const c = require('./theme/colors');
const Flex_1 = require('./Flex');
const MotivationalQuote_1 = require('./MotivationalQuote');
const Navigation_1 = require('./Navigation');
const NavigationBackIcon_1 = require('./NavigationBackIcon');
const RunningDuration_1 = require('./RunningDuration');
const Screen_1 = require('./Screen');
const StartTaskButton_1 = require('./StartTaskButton');
const mapStateToProps = (state, props) => ({
    task: selectors_1.taskSelector(state, props.params.taskId),
});
const mapDispatchToProps = (dispatch) => ({
    startTask: (task) => dispatch(tasks_1.startTask(task)),
    stopTask: (task) => dispatch(tasks_1.stopTask(task)),
});
class RunningTaskScreen extends React.Component {
    render() {
        const { task } = this.props;
        return (React.createElement(Screen_1.Screen, null, 
            React.createElement(Navigation_1.default, {leftIcon: React.createElement(NavigationBackIcon_1.default, null), rightIcon: null, title: task.name}), 
            React.createElement(Screen_1.ScreenContent, {style: style.screenContent}, 
                React.createElement(Flex_1.Column, {style: style.section}, 
                    React.createElement(RunningDuration_1.RunningTaskDuration, {active: !!task.activeSession, style: style.taskDuration, task: task}), 
                    React.createElement(RunningDuration_1.RunningGoalDuration, {active: !!task.activeSession, style: style.goalDuration, task: task})), 
                React.createElement(Flex_1.Column, {style: style.section}, 
                    React.createElement(StartTaskButton_1.default, {task: task, style: style.startTaskButton})
                ), 
                React.createElement(Flex_1.Column, {style: style.section}, 
                    React.createElement(MotivationalQuote_1.default, {style: style.quote})
                ))));
    }
}
;
const style = {
    screenContent: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        marginLeft: 0,
        marginRight: 0,
    },
    section: {
        alignItems: 'center',
        flex: 1,
        justifyContent: 'center',
    },
    taskDuration: {
        fontSize: '22px',
        fontWeight: 'bold',
        marginBottom: '20px',
    },
    goalDuration: {
        color: c.white,
        fontSize: '16px',
    },
    startTaskButton: {
        marginBottom: '20px',
    },
    quote: {
        fontStyle: 'italic',
        lineHeight: '1.5em',
        padding: '0 16px',
        textAlign: 'center',
    },
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(RunningTaskScreen);



/** WEBPACK FOOTER **
 ** ./src/components/RunningTaskScreen.tsx
 **/